<template>
	<div>
		<section id="content">
			<div class="container">
				<br/>

				<!-- NEW COMPONENT HERE -->
				<div class="filter is-mobile">

					<h2>Search Form</h2>

					<div class="columns">
						<div class="column">
							<div class="field">
								<label>Description</label>
								<div class="control">
									<input class="input" type="text" placeholder="Please type something..." v-model="description" />
								</div>
							</div>
						</div>
						<div class="column">
							<div class="field">
							  <label>Moved/Seconded by</label>
							  <div class="control is-expanded">
							    <div class="select is-fullwidth">
							      <select v-model="councillor">
							      	<option disabled value="">Please select one</option>
							      	<option value="">-ALL-</option>
							        <option v-for="c in councillors">{{ c.councillor }}</option>
							      </select>
							    </div>
							  </div>
							</div>
						</div>
						<div class="column">
							<div class="field">
							  <label>Status</label>
							  <div class="control is-expanded">
							    <div class="select is-fullwidth">
							      <select v-model="status">
							      	<option disabled value="">Please select one</option>
							      	<option value="">-ALL-</option>
							        <option v-for="item in statusList" v-bind:value="item.CARRIED_LOST">{{ item.LABEL }}</option>
							      </select>
							    </div>
							  </div>
							</div>
						</div>
						<div class="column">
							<div class="field">
							  <label>Progress</label>
							  <div class="control is-expanded">
							    <div class="select is-fullwidth">
							      <select v-model="progress">
							      	<option disabled value="">Please select one</option>
							      	<option value="">-ALL-</option>
							        <option v-for="p in progressList" v-bind:value="p.PERCENT_COMPLETE">{{ p.LABEL }}</option>
							      </select>
							    </div>
							  </div>
							</div>
						</div>						
					</div>

					<div class="sliderSection"><label>Year</label>
						<vue-slider ref="yearSlider" v-model="valueYear" v-bind="optionsYear"></vue-slider>
					</div>

				</div>



              <div class="modal" v-bind:class="{'is-active' : loading}">
                <div class="modal-background"></div>
                <div class="modal-content has-text-centered">
                  <h1 class="title is-3 has-text-light">Please wait... loading data</h1>
                  <button class="button is-info is-loading is-fullwidth is-large" style="font-size: 5em; background: transparent;">
                    Submitting
                  </button>
                </div>
              </div>



				<div class="summary">
					<small class="rowCount">Showing <b>{{  itemCount }}</b> records
					<template v-if="valueYear[0] == valueYear[1]">
						<label>in <strong>{{ valueYear[0] }}</strong></label>
					</template>
					<template v-else>
						<label>between <strong>{{ valueYear[0] }} - {{ valueYear[1] }}</strong></label>
					</template>
					</small>
				</div>



				<table id="results-table" class="rtable rtable--flip" style="margin-bottom: 30px; white-space:normal;">
					<thead>
						<tr>
							<th>Item #</th>
							<th>Minute Page</th>
							<th>Item Description</th>
							<th>Moved/Seconded</th>
							<th class="has-text-centered">Carried</th>
							<th class="has-text-centered">Progress</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="(dates, date) in searchedArticles">

							<tr ><td colspan="6"><strong>{{ dateFormat(date) }}</strong></td></tr>

							<template v-for="(list, type) in dates">
								<!-- <tr v-if="type != 'Council Meeting'"><td colspan="6" class="highlight">{{ type }}</td></tr> -->
								<tr><td colspan="6" class="highlight">{{ type }}</td></tr>
								<tr v-for="(item, index) in list">
									<td>{{ item.ITEM_NUMBER }}</td>
									<td>{{ item.MINUTE_PAGE.replace(' ','') }}</td>
									<td>
										<p>{{ item.ITEM_DESCRIPTION }}</p>
										
								      	<a v-if="item.RESOLUTION" @click="item.modalResolution = true"><span class="icon">
											<i class="fa fa-comment"></i>
										</span>Resolution</a>

											<div v-if="item.RESOLUTION" class="modal" v-bind:class="{'is-active' : item.modalResolution}">
											  <div class="modal-background"></div>
											  <div class="modal-content">
											    <div class="notification has-background-light ">
												  <button class="delete" @click="item.modalResolution = false"></button>
												  <div v-html="item.RESOLUTION" style="white-space: pre-wrap"></div>
												</div>

											  </div>
											  <button class="modal-close is-large" aria-label="close" @click="item.modalResolution = false"></button>
											</div>

										<template v-if="item.actions.length > 0">
											
											<template v-if="item.actions.length > 1 || (item.actions.length = 1 && item.actions[0].public_comments != '')">

										      	<a v-if="item.actions" @click="item.modalAction = true"><span class="icon">
													<i class="fa fa-comment"></i>
												</span>Action</a>

													<div v-if="item.actions" class="modal" v-bind:class="{'is-active' : item.modalAction}">
													  <div class="modal-background"></div>
													  <div class="modal-content">
													    <div class="notification is-primary">
														  <button class="delete" @click="item.modalAction = false"></button>
														  			
																	<template v-for="(action, actionName) in item.actions">
																		<!-- <template v-if="actionName = 'actions'"> -->
																			
																			<div v-html="action.public_comments" style="white-space: pre-wrap"></div>
																			<hr v-if="item.actions.length > 1" />

																		<!-- </template> -->
																	</template>	
														</div>

													  </div>
													  <button class="modal-close is-large" aria-label="close" @click="item.modalAction = false"></button>
													</div>

												</template>
	 
										</template>



									</td>

									<td>
										<span v-if="item.MOVED">{{ item.MOVED }}</span>
										<span v-if="item.SECONDED">/ {{ item.SECONDED }}</span>
									</td>
									<td class="has-text-centered">{{ item.CARRIED_LOST }}</td>
									<td class="has-text-centered">
										<template v-if="item.PERCENT_COMPLETE == 1">
											<span class="icon is-small is-left" style="color: green;">
												<i class="fa fa-check"></i>
											</span>
										</template>
										<span v-else-if="item.PERCENT_COMPLETE == 0">0%</span>
										<span v-else>{{ item.PERCENT_COMPLETE *100 }}%</span>
									</td>
								</tr>
							</template>
						</template>
					</tbody>
				</table>


			</div>
		</section>

	</div>
</template>
<script>

	import moment from 'moment'; 

    export default {

        data() {
        	return {
        		dateItems: [],
        		itemCount: 0,
        		councillors: [],
        		councillor: '',
        		progress: '',
        		progressList: [],
        		status: '',
        		loading: false,
        		statusList: [],
        		description: '',
                valueYear: [ 0, 0 ],
                optionsYear: {
                    tooltipDir: 'bottom',
                    piecewise: true,
                    piecewiseLabel: true,
                    data: []
                }
        	}
        },

        mounted() {
        	this.loading = true;
        	this.getItems(),
        	this.getYearRange(),
        	this.getCouncillors(),
        	this.getProgress(),
        	this.getStatus()
        },
  		
  		created: function() {
        	this.counter = 0;
    	},

        computed: {

	        searchedArticles() {

 				var searchRegex = new RegExp(this.description, 'i');
            	var searchedArray = {};

				this.itemCount=0;

				for(var date in this.dateItems) {
					var i = 0;
					searchedArray[date] = {};
					var insertedItem = false;

					for( var meeting in this.dateItems[date] ) {

						searchedArray[date][meeting] = [];

						for( var item in this.dateItems[date][meeting] ) {

							var currItem = this.dateItems[date][meeting][item];


							var itemMatches = (this.searchQuery == '') ? true :  (
																					currItem.ITEM_DESCRIPTION.toLowerCase().indexOf(this.description.toLowerCase()) > -1
																					);

							var councillorMatches = (this.councillor == '') ? true :  (
																					currItem.SECONDED.toLowerCase().indexOf(this.councillor.toLowerCase()) > -1 || 
																					currItem.MOVED.toLowerCase().indexOf(this.councillor.toLowerCase()) > -1
																					);

							var statusMatches = (this.status == '') ? true :  (
																					currItem.CARRIED_LOST.toLowerCase().indexOf(this.status.toLowerCase()) > -1
																					);

							if (this.progress == '') {
								var progressMatches = parseFloat(currItem.PERCENT_COMPLETE) >= 0	
							} else if(this.progress > 0 && this.progress < 1) {
	                    		var progressMatches =  parseFloat(currItem.PERCENT_COMPLETE) !== 0 && parseFloat(currItem.PERCENT_COMPLETE) !== 1
	                    	} else if(this.progress == 0 || this.progress == 1) {
	                    		var progressMatches =  parseFloat(currItem.PERCENT_COMPLETE) == this.progress	
	                    	} else {
	                    		var progressMatches =  parseFloat(currItem.PERCENT_COMPLETE) >= 0
	                    	} 


							if( itemMatches &&  councillorMatches && statusMatches && progressMatches && currItem.MEETING_DATE.substring(0,4) >= this.valueYear[0] && currItem.MEETING_DATE.substring(0,4) <= this.valueYear[1]) {
								this.itemCount++;
								insertedItem = true;

								// create new item to handle modal popups
								// currItem['modalResolution'] = false;
								// currItem['modalAction'] = false;

								searchedArray[date][meeting].push(currItem);
							}

			                i++;

		            	}
		            }

		            if(!insertedItem) {
		            	delete searchedArray[date];
		            }

	            }

	            return searchedArray;

	        }



        },

        methods: {

			getItems: function() {
				axios.get('/api/resolutions')
					.then(response => {
						this.dateItems = response.data;
						this.loading = false;
					});
			},

            getYearRange: function() {
                axios.get('/api/resolutions/yearRange')
                    .then(response => { 
                        this.optionsYear.data = response.data;
                        this.valueYear = [this.optionsYear.data[this.optionsYear.data.length -1]-1, this.optionsYear.data[this.optionsYear.data.length -1]]
                    });  
            },

            getCouncillors: function() {
				axios.get('/api/resolutions/councillors')
					.then(response => {
						this.councillors = response.data;
					});
            },

            getProgress: function() {
				axios.get('/api/resolutions/progress')
					.then(response => {
						this.progressList = response.data;
					});
            },

            getStatus: function() {
				axios.get('/api/resolutions/status')
					.then(response => {
						this.statusList = response.data;
					});
            },

	        dateFormat(date) {

	        	date = moment(date)
	        	return date.format('dddd, Do MMMM YYYY')

	        }              

        }
    }

</script>
<style>
	.stripe { background: #f9f9f9; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; }
	.no-border td { border: 0px;  }
	.table.is-striped.no-border tbody tr:not(.is-selected):nth-child(even) td:not(.dateHeader) {
		border-top: 1px solid #dbdbdb;
		border-bottom: 1px solid #dbdbdb;
	}

	td.dateHeader {
		background: #fff;
		border-bottom: 3px solid #333;
		font-weight: bold;
		padding-top: 1em;
	}
	.minutePage {
		white-space: nowrap;
	}
	.seconded span {
		white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// Modules/Register/Resources/assets/js/components/Resolutions.vue